'use strict';

/**
* @ngdoc service
* @name tcApp.LegacyScopeTweakService
* @description
* Contains code to tweak elements in scope to emulate their legacy behaviour
*
*/
angular.module('tc.legacyScope').factory('LegacyScopeTweakService', function($log, LegacyScopeUtilsService) {
	var changePropertyDefinition = function() {
		return {
			get: function() {
				return this.onChangeHandler;
			},
			set: function(fn) {
				// New handler should replace old handler. Event listeners are separate
				this.onChangeHandler = fn;
			},
			configurable: true
		};
	};

	var idPropertyDefinition = function(key, listRowIndex, dynamicColumnIndex) {
		return {
			get: function() {
				if (angular.isDefined(listRowIndex)) {
					if (typeof dynamicColumnIndex === 'number') {
						return (key + 'z' + (listRowIndex + 1) + '.' + (dynamicColumnIndex + 1));
					} else {
						return (key + 'z' + (listRowIndex + 1));
					}
				} else {
					return key;
				}
			},
			configurable: true
		};
	};

	var checkedPropertyDefinition = {
		get: function() {
			return this.value;
		},
		set: function(set) {
			this.value = set;
		},
		configurable: true
	};

	var selectedIndexPropertyDefinition = {
		get: function() {
			return (this.options.length > 0) ? 0 : -1;
		},
		configurable: true
	};

	var listboxValuePropertyArray = [];
	var listboxValuePropertyDefinition = {
		get: function() {
			listboxValuePropertyArray.length = 0;
			if (this.options.length == 0) return '';
			if (this.options.length == 1) return this.options[0].value.toString();
			for (var j = 0; j < this.options.length; j++) {
				listboxValuePropertyArray.push(this.options[j].value);
			}
			return listboxValuePropertyArray;
		},
		configurable: true
		/*,
		set: function(selectedIndex) { this.value = [this.options[selectedIndex]]; }
		*/
	};
		
	var getAttributeDefinition = function(attrName) {
		if (attrName === 'required') {
			if (this.required) return 'Y';
		} else if (attrName === 'value') {
			return this.value;
		} else if (angular.isDefined(this[attrName])) {
			return this[attrName];
		}
		return '';
	};
	
	var optionLengthPropertyDefinition = {
		get: function() {
			return this.options.length;
		},
		configurable: true
	};
	
	var extendItemObject = function(key, item, listRowIndex, dynamicColumnIndex) {
		// existing component JS expects numerical values to be strings
		if (typeof item.value == 'number') {
			item.value = item.value.toString();
		}
		
		if (!item.hiddenItem) {
			if (item.displayType === 'L') {
				Object.defineProperty(item, 'selectedIndex', selectedIndexPropertyDefinition);
				Object.defineProperty(item, 'value', listboxValuePropertyDefinition);
				if (item.options) {
					// Some scripts incorrectly access this instead of options.length
					Object.defineProperty(item, 'length', optionLengthPropertyDefinition);
					
					// Scripts check the 'selected' attribute of the option, rather than the listbox.value
					// (md-select does not two way bind ng-selected value)
					//for (var optionIndex = 0; optionIndex < item.options.length; optionIndex++) {
					//	Object.defineProperty(item.options[optionIndex],'selected', 
					//		optionSelectedPropertyDefinition(item));
					//}
				}
			}
			if (item.displayType === 'C') {
				Object.defineProperty(item, 'checked', checkedPropertyDefinition);
			}
			if (['T','TA','HRT','HTB','C','L'].indexOf(item.displayType) !== -1) {
				Object.defineProperty(item, 'onchange', changePropertyDefinition(key, listRowIndex));				
				Object.defineProperty(item, 'onblur', changePropertyDefinition(key));
				Object.defineProperty(item, 'onclick', changePropertyDefinition(key));
			}
			if (typeof item.style === 'undefined') item.style = {};
			angular.extend(item.style, {
				visibility: 'visible'
			});
		}
		Object.defineProperty(item, 'id', idPropertyDefinition(key, listRowIndex, dynamicColumnIndex));
		item.getAttribute = getAttributeDefinition;
		item.setAttribute = function() {};
		item.focus = function() {};
		item.select = function() {};
		item.scrollIntoView = function() {
			$log.warn('Call to scrollIntoView');
		};
		if (typeof listRowIndex !== 'undefined') {
			item._listRowIndex = listRowIndex;
		}
		if (typeof dynamicColumnIndex === 'number') item._dynamicColumnIndex = dynamicColumnIndex;
	};

	var tweakItems = function($scope) {
		if ($scope.viewModel.itemsTweaked) return;
		
		if ($scope.data.items) {
			angular.forEach($scope.data.items, function(item, key) {
				if (key !== 'elements') {
					extendItemObject(key, item);
				}
			});
		}
		if ($scope.data.listRows) {
			tweakRowItemsFromRowOnward($scope, 0);
		}

		$scope.viewModel.itemsTweaked = true;

	};
	
	var tweakRowItemsFromRowOnward = function($scope, startRowIndex) {
		for (var listRowIndex = startRowIndex; listRowIndex < $scope.data.listRows.length; listRowIndex++) {
			angular.forEach($scope.data.listRows[listRowIndex], function(item, itemName) {
				if (itemName.startsWith('_') || itemName.startsWith('$')) return;

				if (LegacyScopeUtilsService.isDynamicColumnCollection(item)) {
					item.forEach((dynamicColumnItem, dynamicColumnIndex) => {
						extendItemObject(itemName, dynamicColumnItem, listRowIndex, dynamicColumnIndex);	
					});
				} else {
					extendItemObject(itemName, item, listRowIndex);	
				}
			});
		}
	};
	
	// List rows are tweaked to include some properties for backwards compatibility.
	// This function can be used to prevent operations on these properties
	var isListRowMetaData = function(itemName) {
		var metaDataProperties = ['rowIndex','sectionRowIndex','TRAKListIndex','id','cells','style','getElementsByTagName'];
		return (itemName.startsWith('$$') || itemName.startsWith('_') || metaDataProperties.includes(itemName));
	};
	
	return {
		extendItemObject: extendItemObject,
		tweakItems: tweakItems,
		tweakRowItemsFromRowOnward: tweakRowItemsFromRowOnward,
		isListRowMetaData: isListRowMetaData
	};
});
